import React from "react";
import type { ChatMessage as ChatMessageModel } from "./chatMessages";
import ChatMessage from "./ChatMessage.component";
import styles from "./AiChat.module.scss";

export interface ChatMessageListProps {
  messages: ChatMessageModel[];
  onRetry: () => void;
}

/** Scrolling thread of chat bubbles. Keeps the view pinned to the newest
 *  message as the conversation grows. */
const ChatMessageList: React.FC<ChatMessageListProps> = ({
  messages,
  onRetry,
}) => {
  const endRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const behavior = window.matchMedia("(prefers-reduced-motion: reduce)")
      .matches
      ? "auto"
      : "smooth";
    endRef.current?.scrollIntoView({ behavior, block: "end" });
  }, [messages]);

  return (
    <div className={styles.thread}>
      {messages.map((message) => (
        <ChatMessage key={message.id} message={message} onRetry={onRetry} />
      ))}
      <div ref={endRef} />
    </div>
  );
};

export default React.memo(ChatMessageList);
